import {createColumnHelper} from '@tanstack/react-table'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import SVG from 'react-inlinesvg'
import {Link} from 'react-router-dom'
import {formatNumber} from '../../../_metronic/helpers'
export interface IProfitAndLoss {
  classification: string
  parentLedger?: string
  subLedger?: string | null
  amount: number
  ledgerId?: number | null
  children?: IProfitAndLoss[]
  groupId?: number
}

const columnHelper = createColumnHelper<IProfitAndLoss>()

const getProfitAndLossColumns = (from?: string, to?: string) => [
  columnHelper.accessor('classification', {
    header: () => <span className='px-3'>Parent Group</span>,

    cell: ({row, getValue}) => {
      return (
        getValue() && (
          <div className='d-flex align-items-center max-w-125px px-3'>
            {row.depth === 0 ? (
              <span
                {...{
                  onClick: (e) => {
                    e.stopPropagation()
                    row.toggleExpanded()
                  },
                  style: {cursor: 'pointer'},
                  className: 'align-self-end',
                }}
              >
                {row.getIsExpanded() ? (
                  <KTIcon iconName='up' className='text-dark fs-2' />
                ) : (
                  <KTIcon iconName='down' className='text-dark fs-2' />
                )}
              </span>
            ) : (
              <></>
            )}
            <Link
              to={`/transactions/trial-balance/group?group_id=${
                row.original.groupId || null
              }&from=${from}&to=${to}`}
              className='text-dark text-hover-primary'
              style={{fontSize: '13px', fontWeight: '700'}}
            >
              {getValue()}
            </Link>
          </div>
        )
      )
    },
  }),
  columnHelper.accessor('parentLedger', {
    header: () => <span className='px-3'>Parent Ledger</span>,

    cell: ({getValue, row}) => {
      let className = ''
      if (row.depth === 1) {
        className = `text-dark text-hover-primary`
        let url = `/transactions/trial-balance/ledger?ledgerId=${row.original.ledgerId}&from=${from}&to=${to}`
        return (
          <div className='d-flex align-items-start min-w-125px fw-medium'>
            {row.original.children && row.original.children.length > 0 && (
              <span
                {...{
                  onClick: (e) => {
                    e.stopPropagation()
                    row.toggleExpanded()
                  },
                  style: {cursor: 'pointer'},
                  className: 'align-self-end',
                }}
              >
                {row.getIsExpanded() ? (
                  <KTIcon iconName='up' className='text-dark fs-2' />
                ) : (
                  <KTIcon iconName='down' className='text-dark fs-2' />
                )}
              </span>
            )}
            <Link
              to={url}
              className={className}
              style={{
                fontWeight: '500',
                fontSize: '12px',
                color: '#343541',
              }}
            >
              {getValue()}
            </Link>
          </div>
        )
      }
      return null
    },
  }),
  columnHelper.accessor('subLedger', {
    header: () => <span className='px-3'>Sub Ledger</span>,
    cell: ({getValue, row}) => {
      // console.log(row)
      // if (!getValue()) return null

      let url = `/transactions/trial-balance/ledger?ledgerId=${row.original.ledgerId}&from=${from}&to=${to}`

      return (
        <Link
          to={url}
          style={{
            fontWeight: '500',
            fontSize: '10px',
            color: '#444654',
          }}
          className='text-muted text-hover-primary'
          key={row.id}
        >
          <em> {getValue()}</em>
        </Link>
      )
    },
  }),
  // columnHelper.accessor('amount', {
  //   cell: ({row, getValue}) => (
  //     <div
  //       className={
  //         row.depth === 0
  //           ? ' text-dark fw-bolder fs-2 text-end'
  //           : row.depth === 1
  //           ? 'text-dark fw-bold'
  //           : ''
  //       }
  //     >
  //       {getValue()}
  //     </div>
  //   ),
  // }),
  columnHelper.accessor((row) => row.amount, {
    id: 'ledgerAmount',

    header: () => <span className='text-end'></span>,
    cell: ({row, getValue}) => (
      <div
        className={
          row.depth === 1 ? 'text-dark text-end' : row.depth > 1 ? 'text-end text-muted' : 'd-none'
        }
        style={
          row.depth === 1
            ? {
                fontWeight: '500',
                fontSize: '12px',
                color: '#343541',
              }
            : {
                fontWeight: '500',
                fontSize: '10px',
                color: '#444654',
                fontStyle: 'italic',
              }
        }
      >
        {row.depth > 0 ? formatNumber(getValue(), 'en-us', 1, 1) : ''}
      </div>
    ),
  }),
  columnHelper.accessor((row) => row.amount, {
    id: 'groupAmount',
    header: () => <span className='text-end'>Amount</span>,
    cell: ({row, getValue}) => (
      <div
        className={row.depth === 0 ? 'text-dark text-end' : 'd-none'}
        style={{fontSize: '13px', fontWeight: '700'}}
      >
        {row.depth === 0 ? formatNumber(getValue(), 'en-us', 1, 1) : ''}
      </div>
    ),
  }),
]

export {getProfitAndLossColumns}
